import React from 'react';
import '../styles/Testimonials.scss';

const Testimonials = () => {
    return (
        <section className="testimonials">
            <div className="container">
                <h2>Voices from the Void</h2>
                <div className="testimonial-grid">
                    <div className="card">
                        <p>"The view of Saturn's rings from the Titan Resort is something I'll never forget. Worth every credit."</p>
                        <h4>- Elon M.</h4>
                    </div>
                    <div className="card">
                        <p>"Service on the Stargazer was impeccable. Zero-G sushi is a must-try!"</p>
                        <h4>- Sarah C.</h4>
                    </div>
                    <div className="card">
                        <p>"Finally, a vacation that actually feels like an escape. Mars is beautiful this time of year."</p>
                        <h4>- Dr. Stone</h4>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
